export enum TabsValue {
  Analysis = 'analysis',
  Campaign = 'campaign',
  Notes = 'notes',
  Email = 'email',
  CandidateDetails = 'candidateDetails',
  MeetingNotes = 'meetingNotes'
}
